// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"progressbar-module__wrapper___3tNQU","progress":"progressbar-module__progress___2fyEr"};